import React from "react";
import { Loader2 } from "lucide-react";

const LoadingScreen = ({ message = "Cargando..." }) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center ">
      <Loader2 className="animate-spin w-16 h-16 mb-4 mx-auto text-blue-500" />
      {/* <h1 className="text-2xl text-gray-700">{message}</h1> */}
    </div>
  );
};

export default LoadingScreen;
